(function () {
  if (window.__AE_CART_FORM_SYNC__) return;
  window.__AE_CART_FORM_SYNC__ = true;

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;

      const isDrawerForm = form.matches(
        '#scd-quote_btn form,' +
        '#scd-ndis form,' +
        '#scd-package_provider form,' +
        '#scd-book_trial form'
      );

      if (!isDrawerForm) return;

      if (form.dataset.aeCartReady === 'true') {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );

      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        const root =
          window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root
            ? Shopify.routes.root
            : '/';

        const response = await fetch(
          root + 'cart.js?timestamp=' + Date.now(),
          {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error('Unable to retrieve current cart');
        }

        const cart = await response.json();

        /* Remove stale Liquid-generated product fields */
        form
          .querySelectorAll(
            'input[name^="contact[product_"]'
          )
          .forEach(function (input) {
            input.remove();
          });

        /* Add the CURRENT Shopify cart products */
        cart.items.forEach(function (item, index) {
          const input = document.createElement('input');

          input.type = 'hidden';
          input.name =
            'contact[product_' +
            (index + 1) +
            ']';

          let details =
            'Product Title - ' +
            (item.product_title || item.title);

          if (
            item.variant_title &&
            item.variant_title !== 'Default Title'
          ) {
            details +=
              '\nVariant - ' +
              item.variant_title;
          }

          details +=
            '\nQuantity - ' +
            item.quantity;

          if (item.url) {
            details +=
              '\nProduct Link - ' +
              window.location.origin +
              item.url;
          }

          input.value = details;

          form.appendChild(input);
        });

        form.dataset.aeCartReady = 'true';

        if (submitButton) {
          submitButton.disabled = false;
        }

        form.requestSubmit();

      } catch (error) {
        console.error(
          'Adaptive Equipment cart form sync error:',
          error
        );

        form.dataset.aeCartReady = 'true';

        if (submitButton) {
          submitButton.disabled = false;
        }

        form.requestSubmit();
      }
    },
    true
  );
  document.addEventListener('change', function (event) {
  if (event.target.id !== 'QuoteDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#QuoteDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#QuoteDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'NdisDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#NdisDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#NdisDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'PackageDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#PackageDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#PackageDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'TrialDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#TrialDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#TrialDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'CartQuoteDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#CartQuoteDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#CartQuoteDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'CartNdisDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#CartNdisDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#CartNdisDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'CartPackageDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#CartPackageDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#CartPackageDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'CartTrialDeliveryRequired') return;

  const form = event.target.closest('form');
  if (!form) return;

  const addressWrapper = form.querySelector(
    '#CartTrialDeliveryAddressWrapper'
  );

  const addressField = form.querySelector(
    '#CartTrialDeliveryAddress'
  );

  if (!addressWrapper || !addressField) return;

  if (event.target.value === 'Yes') {
    addressWrapper.style.display = 'block';
    addressField.required = true;
  } else {
    addressWrapper.style.display = 'none';
    addressField.required = false;
    addressField.value = '';
  }
});
})();